
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.041 2.4a1.975 1.975 0 100 3.95 1.975 1.975 0 000-3.95zM5.766 4.375a3.275 3.275 0 111.467 2.731l-2.23 2.228.706.706a.65.65 0 11-.919.92l-.706-.707-.831.83.706.707a.65.65 0 11-.919.92l-1.167-1.167a.65.65 0 010-.92L3.6 8.9a.654.654 0 01.05-.05l2.664-2.662a3.26 3.26 0 01-.547-1.812z","fill":"#fff"}})])
          )
        }
      }
    